export default __webpack_public_path__ + "static/media/roll.410dc20f.svg";